import React from "react";
import clsx from "clsx";

import { DatePickerFieldWrapperProps, DatePickerFromToProps } from "types";

import styles from "../formFields/formField.module.scss";

const DatePickerFieldWrapper = ({
	input: { name, value, onChange, onBlur, onFocus },
	meta: { touched, error },
	datePickerComponent,
	connectDatePickerFn,
	connectionName,
	placeholderText,
	className,
	wrapperClassName,
	minDate,
	maxDate,
	disabled,
	disabledSearch,
}: DatePickerFieldWrapperProps & DatePickerFromToProps) => {
	const Component = datePickerComponent;

	const inputErrorClass = touched && error && styles.dayPickerInputError;

	return (
		<Component
			name={name}
			value={value}
			placeholderText={placeholderText}
			className={clsx(className, inputErrorClass)}
			wrapperClassName={wrapperClassName}
			onChange={onChange}
			onBlur={onBlur}
			onFocus={onFocus}
			minDate={minDate}
			maxDate={maxDate}
			connectDatePickerFn={connectDatePickerFn}
			connectionName={connectionName}
			disabled={disabled}
			disabledSearch={disabledSearch}
		/>
	);
};

export default DatePickerFieldWrapper;
